import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { byValue, occurrence, ascending, descending } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import useDidUpdateEffect from '@Hooks/useDidUpdateEffect';

const barChartCheckboxesDialogLifecycle = (Component) => {
  function BarChartCheckboxesDialogLifecycleHOC(props) {
    const {
      filter,
      sorting,
      filterId,
      activeChunk,
      sortingType,
      activeChunkIndex,
      getGroupsAsChunks,
      syncAllChunksWithGroups,
      keyifyParamsForFiltersRequest,
      id: dialogId,
      customGroupsData,
      getCustomGroupsData,
      activeCustomGroupIndex,
      setActiveCustomGroupIndex,
      customGroupsWithByValueSorting,
      activeCustomGroupLetter,
    } = props;

    useEffect(() => {
      syncAllChunksWithGroups(keyifyParamsForFiltersRequest, filterId);

      if (activeChunk) {
        return;
      }

      if (customGroupsWithByValueSorting) {
        if (!customGroupsData) {
          getCustomGroupsData(filter, sortingType, sorting);
          return;
        }
        if (!activeCustomGroupIndex) {
          setActiveCustomGroupIndex(dialogId, customGroupsData[0].index);
        }
      }
      if (filter) {
        getGroupsAsChunks(filter, activeChunkIndex, sortingType, sorting, activeCustomGroupLetter, customGroupsWithByValueSorting);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useDidUpdateEffect(
      ([
        // eslint-disable-next-line no-unused-vars
        prevCustomGroupsWithByValueSorting,
        // eslint-disable-next-line no-unused-vars
        prevCustomGroupsData,
        prevActiveCustomGroupIndex,
        prevActiveChunkIndex,
        prevSortingType,
        prevSorting,
      ]) => {
        if (customGroupsWithByValueSorting) {
          if (!customGroupsData) {
            getCustomGroupsData(filter, sortingType, sorting);
            return;
          }
          if (!activeCustomGroupIndex) {
            setActiveCustomGroupIndex(dialogId, customGroupsData[0].index);
          }
        }

        if (
          activeChunkIndex === prevActiveChunkIndex &&
          sortingType === prevSortingType &&
          sorting === prevSorting &&
          activeCustomGroupIndex === prevActiveCustomGroupIndex
        ) {
          return;
        }

        getGroupsAsChunks(
          filter,
          activeChunkIndex,
          sortingType,
          sorting,
          activeCustomGroupLetter,
          customGroupsWithByValueSorting,
          sorting !== prevSorting,
          sortingType !== prevSortingType
        );
      },
      [customGroupsWithByValueSorting, customGroupsData, activeCustomGroupIndex, activeChunkIndex, sortingType, sorting]
    );

    return <Component {...props} />;
  }

  BarChartCheckboxesDialogLifecycleHOC.propTypes = {
    filter: PropTypes.instanceOf(Map),
    sorting: PropTypes.oneOf([ascending, descending]),
    filterId: PropTypes.string,
    activeChunk: PropTypes.object,
    sortingType: PropTypes.oneOf([byValue, occurrence]),
    activeChunkIndex: PropTypes.number,
    getGroupsAsChunks: PropTypes.func,
    syncAllChunksWithGroups: PropTypes.func,
    keyifyParamsForFiltersRequest: PropTypes.string,
    id: PropTypes.string,
    customGroupsData: PropTypes.array,
    getCustomGroupsData: PropTypes.func,
    activeCustomGroupIndex: PropTypes.number,
    setActiveCustomGroupIndex: PropTypes.func,
    customGroupsWithByValueSorting: PropTypes.bool,
    activeCustomGroupLetter: PropTypes.string,
  };

  return BarChartCheckboxesDialogLifecycleHOC;
};

export default barChartCheckboxesDialogLifecycle;
